import React from 'react'
import './styles/purchase.css'
export const PurchasePage = () => {
  return (
    <main className='main'>
      <h1>Your payment was made successfully</h1>
    </main>
  )
}
